import { getTemplate, registerPartial, ControlTemplate } from 'dac-web-ui';
import html from '../../templates/initform.module.hbs'; 
import selectHtml from '../../templates/select.module.hbs'; 
import inputHtml from '../../templates/input.module.hbs';
import css from '../../css/initform.module.css';

const INNER_TYPES = {
	STRUCTURES: 'structures',
	LENGTH: 'length',
	WIDTHS: 'widths',
	MESHES: 'meshes',
	CHAPPELS: 'chappels'
};

export class InitFormManager extends ControlTemplate {
	
	constructor( modules, managers ) {
		super();
		this.modules = modules;
		this.managers = managers;
		this.managers.InitFormManager = this;
		this.estructureData = [];
		
		//register partial
		registerPartial( 'select', selectHtml );
		registerPartial( 'input', inputHtml );

		//add css
		this._addStyle( 'initFormStyle', css );
	}

	async init( containerId ) {
		this.estructureData = this.managers.DataManager.data.estructuras;
		await this.#refreshUI( null, containerId );		
	}

	async #refreshUI( errors = null, containerId ) {
		const values = await this._getInitialValues( errors);
		const body = this._strToHTML( getTemplate(values, html) );
		if( containerId ) {
			this._container = document.getElementById( containerId );
		}
		const container = this._container ? this._container : document.body;
		container.innerHTML = '';
		container.appendChild( body );
		
		await this.#addEventListeners();
	}

	async _getInitialValues( errors = null) {
		
		const currentData = this.managers.DataManager.currentData;
		const json = {};

		//GET TYPE OF INVERNADEROS
		json.typesQuestionError = errors && errors.estructura.error ? '*' : '';
		json.typesQuestion = 'Tipo:';
		json.structures = await this.#getInvernaderoTypes();
		
		// SET DEFAULT LENGTH
		json.lengthQuestionError = errors && errors.length.error ? '*' : '';
		json.lengthQuestion = 'Largo Total:';
		json.length = { type: INNER_TYPES.LENGTH, value: currentData.largo ? currentData.largo : '', placeholder: '' };
		
		// GET POSSIBLE WIDTHS
		json.widthsQuestionError = errors && errors.widths.error ? '*' : '';
		json.widthsQuestion = 'Ancho estructura:';
		json.widths = await this.#getInvernaderoWidths();

		// SET DEFAULT CHAPPELS		
		json.chappelsQuestionError = errors && errors.chappels.error ? '*' : '';
		json.chappelsQuestion = 'Numero chapelles:';
		json.chappels = { type: INNER_TYPES.CHAPPELS, value: currentData.capillas ? currentData.capillas : '', placeholder: '' };
		
		// GET ASSOCIATED MESHES
		json.meshesQuestionError = errors && errors.meshes.error ? '*' : '';
		json.meshesQuestion = 'Malla asociada:';
		json.meshes = await this.#getInvernaderoMeshes();
		
		if( errors ) {
			json.showError = errors.estructura.error ||
				errors.length.error ||
				errors.widths.error ||
				errors.meshes.error ||
				errors.chappels.error;
			json.error = 'Por favor, rellene todos los campos';	//TODO: translate
		}

		// GET BUTTONS TEXTS. TODO: TRANSLATE and change also in #onButtonClick
		json.header = 'Configuración Inicial';
		json.submit = 'submit';
		json.cancel = 'cancel';

		return json;
	}

	async #getInvernaderoTypes() {
		const data = this.managers.DataManager.data;
		const currentData = this.managers.DataManager.currentData;
		return {
			type: INNER_TYPES.STRUCTURES,
			values: [ { id: -1, desc: '' } ].concat( 
				data.estructuras.map( 
					( e, index ) => { 
						return { 
							id: index, 
							desc: e.nombre,
							selected: currentData.estructura && currentData.estructura.nombre == e.nombre
						}; 
					} 
				)
			)
		};
	}

	async #getInvernaderoWidths() {
		const currentData = this.managers.DataManager.currentData;
		return {
			type: INNER_TYPES.WIDTHS,
			values: [ { id: -1, desc: '' } ].concat( 
				this.managers.DataManager.getAnchos().
					map( ( e, index ) => 
					{ 
						return { 
							id: index, 
							desc: e,
							selected: currentData.ancho == e
						}; 
					} ) 
			)
		};
	}

	async #getInvernaderoMeshes() {
		const currentData = this.managers.DataManager.currentData;
		return {
			type: INNER_TYPES.MESHES,
			values: [ { id: -1, desc: '' } ].concat( 
				this.managers.DataManager.getMallas().
					map( ( e, index ) => 
					{ 
						return { 
							id: index, 
							desc: e ,
							selected: currentData.malla == e
						}; 
					} ) 
			)
		};
	}

	async #addEventListeners() {
		// get container
		const container = document.getElementById('initForm');
		if( !container ) return;

		// add select change events
		const selects = container.querySelectorAll('select');
		for( let i=0; i < selects.length; i++ ) {
			const select = selects[i];
			select.addEventListener( 'change', async(e) => await this.#onSelectChange( e ) );
		}

		// add input change events
		const inputs = container.querySelectorAll('input');
		for( let i=0; i < inputs.length; i++ ) {
			const input = inputs[i];
			input.addEventListener( 'change', async(e) => await this.#onInputChange( e ) );
		}

		// add button click events
		const buttons = container.querySelectorAll( '.initFormButton' );
		for( let i=0; i < buttons.length; i++ ) {
			const button = buttons[i];
			button.addEventListener( 'click', async(e) => await this.#onButtonClick( e ) );
		}
	}

	async #onSelectChange( event ) {
		const data = event.target.dataset;
		const selectedValue = event.target.value;
		console.log( 'select change', `type:${data.type}, value: ${selectedValue}` );
		switch ( data.type ) {
			case INNER_TYPES.STRUCTURES: {
				//clean current data
				this.managers.DataManager.currentData.estructura = null;
				this.managers.DataManager.currentData.ancho = null;
				this.managers.DataManager.currentData.malla = null;
				this.managers.DataManager.currentData.opcion = null;

				//assign new structure
				const index = parseInt( selectedValue );
				if( index >= 0 )
					this.managers.DataManager.currentData.estructura = this.managers.DataManager.data.estructuras[ index ];

				// refill UI
				this.#refreshUI();

			} break;
			case INNER_TYPES.WIDTHS: {
				if( selectedValue === '' ) this.managers.DataManager.currentData.ancho = null;
				else {
					const width = parseFloat( event.target.selectedOptions[0].innerText );
					this.managers.DataManager.currentData.ancho = width;
				}
			} break;
			case INNER_TYPES.MESHES: {
				if( selectedValue=== '' ) this.managers.DataManager.currentData.malla = null;
				else {
					const malla = parseFloat( event.target.selectedOptions[0].innerText );
					this.managers.DataManager.currentData.malla = malla;
				}
			} break;
		}
	}

	async #onInputChange( event ) {
		const data = event.target.dataset;
		const newValue = event.target.value;

		switch ( data.type ) {
			case INNER_TYPES.LENGTH: {
				try {
					const length = parseFloat( newValue );
					this.managers.DataManager.currentData.largo = length;
				} 
				catch( e ) { console.error( 'error parsing length' ); }
			} break;
			case INNER_TYPES.CHAPPELS: {
				try {
					const chappels = parseFloat( newValue );
					this.managers.DataManager.currentData.capillas = chappels;
				} 
				catch( e ) { console.error( 'error parsing chappels' ); }
			} break;
		}
	}

	async #onButtonClick( event ) {
		const data = event.target.dataset;
		switch ( data.type ) {
			case 'submit': {
				
/*						// 50.000 m2 de invernadero
				this.managers.DataManager.currentData.estructura = {
					'codaqua': 'ASYSTARTER',
					'nombre': 'Invernadero  multicapilla ASY-STARTER'
				};
				this.managers.DataManager.currentData.ancho = 9.6;
				this.managers.DataManager.currentData.largo = 50;//200;
				this.managers.DataManager.currentData.capillas = 10;//40;
				this.managers.DataManager.currentData.malla = 2.5;
*/
				//CHECK IF ALL IS FILLED CORRECTLY
				const errors = this.#checkErrors();
				if( errors.estructura.error || 
					errors.length.error || 
					errors.widths.error || 
					errors.meshes.error || 
					errors.chappels.error ) {
					this.#refreshUI( errors );
					return;
				}
				await this.trigger( 'accept', data ); 
			} break;
			case 'cancel': { 
				await this.trigger( 'cancel' ); 
			} break;
		}
	}

	#checkErrors() {
		const errors = {
			estructura: { error: false, desc: 'Debe seleccionar un tipo de estructura' },
			length: { error: false, desc: 'Debe introducir un valor para el largo' },
			widths: { error: false, desc: 'Debe seleccionar un ancho' },
			meshes: { error: false, desc: 'Debe seleccionar una malla' },
			chappels: { error: false, desc: 'Debe introducir un valor para el numero de capillas' }
		};
		//check if structures is filled
		errors.estructura.error = this.managers.DataManager.currentData.estructura === null;
		//check if length is filled
		errors.length.error = this.managers.DataManager.currentData.largo === null;
		//check if widths is filled
		errors.widths.error = this.managers.DataManager.currentData.ancho === null;
		//check if meshes is filled
		errors.meshes.error = this.managers.DataManager.currentData.malla === null;
		//check if chappels is filled
		errors.chappels.error = this.managers.DataManager.currentData.capillas === null;

		return errors;
	}
}
